import React from 'react'
import { PositionProps } from '../Position/utils'

interface CareersContextProps {
  openings: PositionProps[]
  freePosition: PositionProps | null
}

const defaultValue: CareersContextProps = {
    openings: [],
    freePosition: null,
}

const CareersContext = React.createContext(defaultValue)
export const CareersContextProvider = CareersContext.Provider
export default CareersContext
